import { render } from "./GroupList.vue?vue&type=template&id=19bc7044&scoped=true"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"

import "./GroupList.vue?vue&type=style&index=0&id=19bc7044&lang=css"
import "./GroupList.vue?vue&type=style&index=1&id=19bc7044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bc7044"]])

export default __exports__